import { gql } from '@apollo/client';
import {
  TMS_VEHICLE_TYPE_DETAIL_FIELDS,
  TMS_VEHICLE_TYPE_FIELDS,
  TmsVehicleType,
  TmsVehicleTypeDetail
} from "../../../../../graphql/types/TmsVehicleType";

export const GET_VEHICLES = gql`
  query GetTmsVehicles($warehouseId: Long, $licensePlate: String, $vehicleModelId: Int, $carrierId: Int, $fuelType: Int, $status: Int) {
    allVehicles: getTmsVehicles(
      warehouseId: $warehouseId
      licensePlate: $licensePlate
      vehicleModelId: $vehicleModelId
      carrierId: $carrierId
      fuelType: $fuelType
      status: $status
    ) {
      ...VehicleTypeFields
    }
  }
  ${TMS_VEHICLE_TYPE_FIELDS}
`;

// TMS 内部专属：warehouseId 必填，原 GET_VEHICLES（getTmsVehicles）保持不变，避免影响总部账号管理页等其他调用方
export const GET_VEHICLES_BY_WAREHOUSE_ID = gql`
  query GetTmsVehiclesByWarehouseId($warehouseId: Long!, $licensePlate: String, $vehicleModelId: Int, $carrierId: Int, $fuelType: Int, $status: Int) {
    allVehicles: getTmsVehiclesByWarehouseId(
      warehouseId: $warehouseId
      licensePlate: $licensePlate
      vehicleModelId: $vehicleModelId
      carrierId: $carrierId
      fuelType: $fuelType
      status: $status
    ) {
      ...VehicleTypeFields
    }
  }
  ${TMS_VEHICLE_TYPE_FIELDS}
`;

export const FIND_VEHICLE_BY_ID = gql`
  query FindTmsVehicleById($id: Long!) {
    findTmsVehicleById(id: $id) {
      ...VehicleTypeDetailFields
    }
  }
  ${TMS_VEHICLE_TYPE_DETAIL_FIELDS}
`;

export interface VehiclesResponse {
  allVehicles: TmsVehicleType[];
}

export interface FindVehicleByIdResponse {
  findTmsVehicleById: TmsVehicleTypeDetail;
}

export const GET_VEHICLES_WITH_PAGINATION = gql`
  query GetTmsVehiclesWithPagination(
    $filter: TmsVehicleFiltersInput,
    $pageRequest: PageRequestTypeInput
  ) {
    getTmsVehiclesWithPagination(
      filters: $filter,
      pageRequest: $pageRequest
    ) {
      content {
        ...VehicleTypeFields
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
  ${TMS_VEHICLE_TYPE_FIELDS}
`;

export interface TmsVehiclePageResponse {
  getTmsVehiclesWithPagination: {
    content: TmsVehicleType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
}
